import React, { Component } from 'react';
import './FileImport.scss';

import counterpart from 'counterpart';
import { fetchFilterValuesBasedOnElementId } from 'Apis/queueManagerApi.js';
import SelectInput from 'Components/forms/select-input/SelectInput.jsx';
import MerchantUploadDocuments from '../../../../dims-common-ui/components/MerchantUploadDocuments/MerchantUploadDocuments';
import ResponseBanner from 'Components/cards/ResponseBanner';
import { getAllRegion } from 'Apis/caseDataAPI.js';
import fileTypeIcon from '../../assets/img/icon-file-type.svg';
import fileUploadIcon from '../../assets/img/icon-file-upload.svg';
import { uploadImportDocument } from 'Apis/imageMatcherApi';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import ImagePortal from '../ImagePortal/ImagePortal';

class FileImport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedAcquirerOptions: {},
      selectedRegionOptions: {},
      acquirerOptions: [],
      acquirerData: [],

      regionOptions: [],
      regionData: [],
      isAcquirerDataLoaded: false,
      isRegionDataLoaded: false,

      hasPermission: false,
      isAcquirerSelected: false,
      isRegionSelected: false,
      isFileImportUploadDoc: true,
      uploadFileList: [],
      isFileLoaded: false,
      showConfirm: false,
      isSuccess: false,
      isCSVLoaded: false,
      newFile: [],
      isUploading: false,
      fileUploadErr: false,
      cardBrandCode : ''
    };
  }

  componentDidMount() {

    this.updateAcquirerOptions();
    this.fetchRegionData();
    this.checkPermissions();
  }

  closeBanner = () => {
    this.setState({
      showConfirm: false,
      isSuccess: false,
      fileUploadErr: false,
    });
  };

  updateNewFile = (newFile) => {
    this.setState({
      newFile: newFile,
    });
  }

  
  resetFullPage = () => {
    this.setState({
      selectedAcquirerOptions: {},
      selectedRegionOptions: {},
      isAcquirerSelected: false,
      isRegionSelected: false,
      uploadFileList: [],
      isFileLoaded: false,
      isCSVLoaded: false,
      regionOptions: [],

    }, () => {
      this.closeBanner();
    })
  };

  checkPermissions = () => {
    const { user } = this.props;
    const { parsedPermissions } = user;
    const hasPermission = parsedPermissions.queue.viewGPNQueues || parsedPermissions.queue.viewHPYQueues;
    this.setState({ hasPermission });
  };

  fileUploaded = (status) => {
    this.setState({
      isFileLoaded: status,
    });
  };

  csvLoaded = (status) => {
    this.setState({
      isCSVLoaded: status,
    });
  };

  getFormattedResponse(response, filter) {
    let filterValues = [];
    response.data.forEach((filterValue) => {
      if (filter === 'pr_acquirer_name') {
        filterValues = [
          ...filterValues,
          {
            id: filterValue.acquirerCode,
            value: filterValue.acquirerCode,
            text: filterValue.acquirerDescription,
          }
        ];

      }
      if (filter === 'fileImport') {
        filterValues = [
          ...filterValues,
          {
            id: filterValue.regionCode,
            value: filterValue.regionCode,
            text: filterValue.regionName,
          }
        ];
      }
    });
    return filterValues;
  }

  showSuccessBanner = () => (
    <ImagePortal>
    <ResponseBanner
      titleStyle={{ color: 'light-green' }}
      descriptionStyle={{ color: 'grey' }}
      valueStyle={{ color: 'black' }}
      title={counterpart('globalTranslate.fileImport.successTitle')}
      description={counterpart('globalTranslate.fileImport.successDesc')}
      type="success"
      successOnly
      primaryButtonText={counterpart('globalTranslate.fileImport.successButtonText')}
      onClose={this.resetFullPage}
      primaryButtonAction={this.resetFullPage}
    />
    </ImagePortal>
  );

  showConfirmationBanner = () => (
    <ImagePortal>
    <ResponseBanner
      titleStyle={{ color: 'light-green' }}
      descriptionStyle={{ color: 'grey' }}
      valueStyle={{ color: 'black' }}
      title={counterpart('globalTranslate.fileImport.confirmTitle')}
      description={counterpart('globalTranslate.fileImport.confirmDesc')}
      onClose={this.closeBanner}
      type="info"
      primaryButtonText={counterpart('globalTranslate.fileImport.primaryButtonText')}
      cancelButtonText={counterpart('globalTranslate.fileImport.cancelButtonText')}
      primaryButtonAction={this.uploadFile}
      isPrimarSecondaryButtonCombo
      secondaryButtonAction={this.closeBanner}
    />
    </ImagePortal>
  );

  updateAcquirerOptions = () => {
    fetchFilterValuesBasedOnElementId('pr_acquirer_name')
      .then((response) => {
        if (response.status.statusCode === 2000) {
          const formattedData = this.getFormattedResponse(response, 'pr_acquirer_name');

          const { user } = this.props;
          const { parsedPermissions } = user;

          // Initialize options array
          let options = [];

          // Find specific entries in the formattedData
          const globalPaymentPinDebit = formattedData.find((item) => item.id === 'GPNPD');
          const heartlandPinDebit = formattedData.find((item) => item.id === 'HPYPD');

          // Check permissions and push options
          if (parsedPermissions.queue.viewGPNQueues && globalPaymentPinDebit) {
            options.push(globalPaymentPinDebit);
          }

          if (parsedPermissions.queue.viewHPYQueues && heartlandPinDebit) {
            options.push(heartlandPinDebit);
          }

          // Update state with the new options
          this.setState({ acquirerOptions: options });
        }
      })
      .catch((error) => {
        console.log('Error Occurred while fetching filter values based on element id', error);
      });
  };

  fetchRegionData = () => {
    getAllRegion('fileImport', false)
      .then((response) => {
        if (response.status.statusCode === 2000) {
          const formattedData = this.getFormattedResponse(response, 'fileImport');
          this.setState({ regionData: formattedData, isRegionDataLoaded: true });
        }
      })
      .catch((error) => {
        this.setState({ regionData: [], isRegionDataLoaded: false });
        console.log('Error Occured while region data ', error);
      });
  };

  updateRegionOptions = () => {
    const { selectedAcquirerOptions } = this.state;

    let options = [];

    if (selectedAcquirerOptions.id === 'GPNPD') {
      options = this.state.regionData.filter(
        (region) => region.id === 'AP' || region.id === 'CA' || region.id === 'US',
      );
    } else {
      options = this.state.regionData.filter((region) => region.id === 'US');
    }

    this.setState({ regionOptions: options,
      cardBrandCode: 'PD'
     });
  };

  displayHeaderContent = () => {
    return (
      <div className="file-import-info-msg">
        <div>
          <span className="file-import-info-msg-desc">{counterpart('globalTranslate.fileImport.headerDesc')}</span>
        </div>
        <div>
          <span className="file-import-info-msg-note">{counterpart('globalTranslate.fileImport.headerNote')}</span>
        </div>
      </div>
    );
  };

  displayFileTypeDropdown = () => {
    return (
      <div className="case-count-detail file-type-box">
        <div className="file-type-dropdown">
          <img src={fileTypeIcon} alt="fileTypeIcon" />
        </div>
        <div className="file-type-button">
          <span className="file-type-header">{counterpart('globalTranslate.fileImport.fileTypeText')}</span>
          <span className="file-type-note"> {counterpart('globalTranslate.fileImport.fileTypeNote')} </span>
        </div>
      </div>
    );
  };

  onAcquirerSelect = (event) => {
    this.setState(
      {
        isRegionSelected: false,
      },
      () => {
        let selectedOption = this.state.acquirerOptions.filter((acquirer) => acquirer.value == event);
        this.setState(
          {
            selectedAcquirerOptions: selectedOption[0],
            isAcquirerSelected: true,
          },
          () => {
            // Callback function to execute after setting `selectedAcquirerOptions` and `isAcquirerSelected`
            this.updateRegionOptions();
          },
        );
      },
    );
  };

  onRegionSelect = (event) => {
    let selectedOption = this.state.regionOptions.filter((region) => region.value == event);
    this.setState({
      selectedRegionOptions: selectedOption[0],
      isRegionSelected: true,
    });
  };

  displayUploadButton = () => (
    <div className="upload-button-container">
      <button
        type="button"
        onClick={() => this.setState({ showConfirm: true })}
        className={this.state.isFileLoaded ? 'enabled-upload-button' : 'disabled-upload-button'}
        style={!this.state.isFileLoaded ? { marginTop: 30 } : {}}

        disabled={!this.state.isFileLoaded}
      >
        <img src={fileUploadIcon} alt="fileUploadIcon" />
        {counterpart('globalTranslate.fileImport.uploadButtonLabel')}
      </button>
    </div>
  );

  displayUploadBox = () => {
    return (
      <div
        className="upload-doc-box"
        style={this.state.isAcquirerSelected && this.state.isRegionSelected ? {} : { pointerEvents: 'none' }}
      >
        <MerchantUploadDocuments
          fileUploaded={this.fileUploaded}
          uploadFileList={this.state.uploadFileList}
          isFileImportUploadDoc={this.state.isFileImportUploadDoc}
          csvLoaded ={this.csvLoaded}
          isCSVLoaded = {this.state.isCSVLoaded}
          acquirerCode = {this.state.selectedAcquirerOptions.id}
          cardBrandCode = {this.state.cardBrandCode}
          updateNewFile={this.updateNewFile}
        />
      </div>
    );
  };

  displayDropdown = () => {
    return (
      <div className="acq-reg-box">
        {/* Acquirer Dropdown */}
        <div className="dropdown-container">
          <label className="dropdown-label">
            {counterpart('globalTranslate.fileImport.acquirerLabel')}
            <span className="label-symbol"> *</span>
          </label>
          <SelectInput
            dataList={this.state.acquirerOptions}
            promptText="Select One"
            promptOnly={!this.state.isAcquirerSelected}
            handleSelection={(event) => this.onAcquirerSelect(event)}
            selectedItem={this.state.selectedAcquirerOptions}
            wrapperClass="select-menu__form"
            disabled={!this.state.hasPermission}
          />
        </div>

        <div className="dropdown-container">
          <label className="dropdown-label">
            {counterpart('globalTranslate.fileImport.regionLabel')}
            <span className="label-symbol"> *</span>
          </label>
          <div style={this.state.isAcquirerSelected ? {} : { opacity: 0.7 }}>
            <SelectInput
              dataList={this.state.regionOptions}
              promptText="Select One"
              promptOnly={!this.state.isRegionSelected}
              handleSelection={(event) => this.onRegionSelect(event)}
              selectedItem={this.state.selectedRegionOptions}
              wrapperClass="select-menu__form"
              disabled={!this.state.isAcquirerSelected}
            />
          </div>
        </div>
      </div>
    );
  };

  displayFileUploadContainer = () => {
    return (
      <div className="fileimport-box">
        <div className="inner-fileimport-box">
          {this.displayDropdown()}
          {this.displayUploadBox()}
          {this.displayUploadButton()}
        </div>
      </div>
    );
  };

  displaySubHeader = () => {
    return (
      <div className="option-buttons-custom">
        <button id="caseimport" className="button-custom">
          {counterpart('globalTranslate.fileImport.subHeader')}
        </button>
      </div>
    );
  };

  uploadFile = () => {
    this.setState({
      isUploading: true,
    });
    const userId = JSON.parse(sessionStorage.getItem('state')).auth.user.userId;
    uploadImportDocument(this.state.newFile,userId,this.state.selectedAcquirerOptions.value,this.state.selectedRegionOptions.value)
    .then((apiResponse) => {
      if (apiResponse.status.statusCode === 200) {
        this.setState({
          isUploading: false,
          isSuccess: true,
        });
      }
    })
      .catch((error) => {
        this.setState({
          isUploading: false,
          fileUploadErr: true,
          showConfirm: false,
        })
        console.log('Error occured while uploading file: ', error);
      });
  }

  showUploadDocErrorBanner() {
    if (this.state.fileUploadErr) {
      return (
        <div>
          <ImagePortal>
          <ResponseBanner
            cancelOnly={true}
            titleStyle={{ color: 'light-green' }}
            descriptionStyle={{ color: 'grey' }}
            valueStyle={{ color: 'black' }}
            title="Error Occured"
            description='Failed to import the file. Please try again, and if the issue still persists, contact the support team.'
            type="danger"
            onClose={this.closeBanner}
            cancelButtonText="DISMISS"
          />
          </ImagePortal>
        </div>
      );
    }
  }
  render() {
    window.document.title = 'File Import';
    return (
      this.state.isUploading ? (<BVLoader20 />) :(
      <section className="fileimport-container">
        {this.state.showConfirm && this.showConfirmationBanner()}
        {this.state.isSuccess && this.showSuccessBanner()}
        {this.showUploadDocErrorBanner()}

        <div className="main-content--header" style={{ zIndex: 2 }}>
          <h1 className="file-import-heading">File Import</h1>
        </div>
        <div className="main-content--wrapper" style={{ width: '100%' }}>
          {this.displayHeaderContent()}
          <div className="SubQueue-custom file-import-sub-header">
            {this.displaySubHeader()}
            {this.displayFileTypeDropdown()}
            {this.displayFileUploadContainer()}
          </div>
        </div>
      </section>)

    );
  }
}

export default FileImport;
